import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#fff',
        padding: '20px',
        margin: '20px auto',
        width: '80%',
        borderRadius: '10px',
        maxHeight: '83vh',
        overflowY: 'auto',
        paddingTop:'40px',
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            maxHeight: '85vh',
            paddingTop:'55px',
        },
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        marginTop: '20px',
        fontSize: '35px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '25px !important',
        },
    },
    cardsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '15px',
        width: '92%',
        [theme.breakpoints.down('sm')]: {
            flexDirection:'column',
        },
    },
    card: {
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        height:'120px',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        borderRadius: '10px',
        padding: '15px',
        textAlign: 'center',
        color:'#fff !important',
        width: '32%',
        [theme.breakpoints.down('sm')]: {
            justifyContent:'flex-start',
            height:'auto',
            width: 'auto',
            margin:'10px 0',
        },
    },
    overviewContainer:{
        backgroundColor:'#EFEFEF',
        borderRadius:'10px',
        padding:'20px',
        width:'92%',
        display:'flex',
        [theme.breakpoints.down('sm')]: {
            flexDirection:'column',
        },
    },
    overview: {
        marginTop: '10px',
        marginBottom: '10px',
        fontSize: '16px',
        textAlign: 'left',
    },
    unit: {
        marginBottom: '10px',
        textAlign: 'left',
    },
    lesson: {
        color: '#0097B2',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0px',
        },
    },
    studentOutcomes: {
        paddingLeft: '30px',
        color: '#474747',
    },
    unitContainer: {
        width: '92%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'left',
        marginTop: '15px',
        alignItems: 'flex-start',
    },
    button: {
        marginTop: '10px',
        backgroundColor: '#0397a6',
        justifyContent: 'left',
        outline: 'none',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#027A85',
        },
    },
    chatBotContainer:{
        position: 'absolute',
        width: '65%',
        bottom:'0',
        padding: '0px',
        borderRadius: '7px',
        [theme.breakpoints.down('sm')]: {
            width: '95%',
        },
    }
}));

export default useStyles;